import { ArticleType } from '@wix/answers-api';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';

import {
  HELPMATE_SUPPORTED_LANGUAGES,
} from '../constants';
import { useWindowSize } from './useWindowSize';
import { Context } from '../context';
import { PageType } from '../types';
import { isTwinsRelated, isWixelRelated } from '../utils/excluded-categories';
import { isMobile, isTablet } from '../utils/user-agent';
import { useStore } from '../zustand/stores';

const useIsHelpCenterCopilotEnabled = () => {
  const context = useContext(Context);
  const article = context.pageTemplateData?.pageData?.article;
  const categoriesTree = useStore(
    (state) => state.categoriesTreeSlice.categoriesTree
  );
  const { locale } = useRouter();
  const [isMobileView, setIsMobileView] = useState(context.isMobile);
  const [isTabletView, setIsTabletView] = useState(context.isTablet);
  const windowSize = useWindowSize();
  useEffect(() => {
    if (windowSize.width) {
      setIsMobileView(isMobile(context));
      setIsTabletView(isTablet(context));
    }
  }, [context, windowSize.width]);

  if (
    !isMobileView &&
    !isTabletView &&
    !article?.title?.includes('Wix Twins') &&
    article?.type === ArticleType.ARTICLE &&
    !isTwinsRelated(
      PageType.Article,
      categoriesTree,
      context.pageTemplateData
    ) &&
    !isWixelRelated(
      PageType.Article,
      categoriesTree,
      context.pageTemplateData
    ) &&
    (HELPMATE_SUPPORTED_LANGUAGES.includes(locale as string))
  ) {
    return true;
  }
  return false;
};

export default useIsHelpCenterCopilotEnabled;
